import { Component, Input, OnInit, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { RequestService } from 'src/app/core/request.service';
import { ActivatedRoute, Router } from '@angular/router';
//import { GooglePlus } from '@ionic-native/google-plus/ngx';
//import { Facebook } from '@ionic-native/facebook/ngx';
import { SocialAuthService, GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { ASAuthorizationAppleIDRequest, SignInWithApple } from '@ionic-native/sign-in-with-apple/ngx';
import { ModalController, Platform } from '@ionic/angular';
import { environment } from '../../../environments/environment'
import { OTPVerificationPage } from '../modals/otp-verification/otp-verification.page';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';


declare var config: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  @Output() onLoginSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onRegisterClick: EventEmitter<any> = new EventEmitter();
  @Output() onForgotPassword: EventEmitter<any> = new EventEmitter();
  @Input() isOrderProcessing: boolean = false;

  // otp verifgication template for web view
  @ViewChild('otpVerification') otpVerificationTemp: TemplateRef<any>;

  /**
   * Login page variables
  */
  public login_details = {
    email: '',
    password: '',
    type: 'registered'
  };

  public mobileVerificationCodeSending: boolean = false;
  public verificationError: string = '';


  password_type: any = 'password';

  public errors: any;
  public is_login: boolean = false;
  public is_facebook_login: any = 'false';
  public is_google_login: any = 'false';
  public is_apple_login: any = 'false';

  plf: string = 'web';

  loginInProgress: boolean = false;

  isGuestUserEnabled: boolean = false;

  public passwordVisible: boolean = false;

  public isCartIconShowing: boolean = false;

  // OTP Verification Page Verification response object for web version
  public otpCodeResponse: { sentVia: string, userData: any, operationType: string } | null = null;

  
  constructor(public appService: AppServiceService,
    //private googlePlus: GooglePlus,
    //private facebook: Facebook,
    private apple: SignInWithApple,
    private route: ActivatedRoute,
    private platform: Platform,
    private router: Router,
    private webAuthService: SocialAuthService,
    public modalController: ModalController
  ) {

    if (this.platform.is('android')) {
      this.plf = 'android';
    } else if (this.platform.is('ios')) {
      this.plf = 'ios';
    }

    this.route.queryParams.subscribe(params => {
      if (params && params.isOrderProcess) {
        this.appService.appObject.isOrderProcess = params.isOrderProcess;
      } else {
        this.appService.appObject.isOrderProcess = false;
        // console.log('noooo');
      }

      if (params) {
        if (params.requestPostalCode) this.appService.isWhileRequestingPostalCode = params.requestPostalCode;
        if (params.requestNewPostalCode) this.appService.isWhileRequestingNewPostalCode = params.requestNewPostalCode;
      }
    });

  }

  ngOnInit() {
    if (this.appService.appObject.selectedRestaurantId == null) {
      if (this.appService.appObject.settings.main_restaurant) {
        this.is_facebook_login = (typeof this.appService.appObject.settings.main_restaurant.is_facebook_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_facebook_login;
        this.is_google_login = (typeof this.appService.appObject.settings.main_restaurant.is_google_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_google_login;
        this.is_apple_login = (typeof this.appService.appObject.settings.main_restaurant.is_apple_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_apple_login;
      }
    } else {
      if (this.appService.appObject.selectedRestaurantDetails) {
        this.is_facebook_login = (typeof this.appService.appObject.selectedRestaurantDetails.is_facebook_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_facebook_login;
        this.is_google_login = (typeof this.appService.appObject.selectedRestaurantDetails.is_google_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_google_login;
        this.is_apple_login = (typeof this.appService.appObject.selectedRestaurantDetails.is_apple_login == "undefined") ? 'false' : this.appService.appObject.settings.main_restaurant.is_apple_login;
      }
    }


    // Check guest user is enabled or not..
    // "this.isOrderProcessing" this value is comming when user is in the web version of the app
    if ((this.appService.appObject.isOrderProcess || this.isOrderProcessing)
      && (!this.appService.closenotice || (this.appService.closenotice && this.appService.isPreOrderAccept))
      && !this.appService.appObject.userVerificationRequired
      && this.appService.appObject.selectedRestaurantDetails.general_order_button === 'true') {
      this.isGuestUserEnabled = true;
    }
  }

  async login() {
    this.loginInProgress = true;
    this.verificationError = '';
    // if user verification is mandatory by the restaurant, then check user verification status before login in
    if (this.appService.appObject.userVerificationRequired) {
      // will return user verification status
      this.appService.checkUserVerifiedStatus(this.login_details).then((loginVerificationResponse) => {
        if (loginVerificationResponse.status) {
          if (loginVerificationResponse.data.is_verified !== 'true') {
            // popup verification process
            let verificatioData = { mobile_number: loginVerificationResponse.data.mobile_number, email: loginVerificationResponse.data.email };
            // request verification code, will check in backend for the method mobile / email and send back the method
            this.appService.requestVerificationCode(verificatioData).then(async (verificationResponse) => {
              // if verification code has been sent, will return the what method used to sent 
              if (verificationResponse.status) {
                this.appService.startVerificationCodeIntervalCountdown();
                // include the password in the data set to check credentials when update user status if the user is successfully verified
                verificatioData['password'] = this.login_details.password;
                let verificationPopUp = null;
                if (this.appService.isWebVersion) {
                  this.otpCodeResponse = verificationResponse;
                  this.otpCodeResponse.userData = verificatioData;
                  this.otpCodeResponse.operationType = 'verification_login';

                  // this.onVerificationCodeSent.emit(verificationResponse);

                  verificationPopUp = await this.modalController.create({
                    component: InputSelectModalComponent,
                    cssClass: 'select-modal',
                    componentProps: {
                      content: this.otpVerificationTemp,
                      hideFooter: true
                    },
                  });
                } else {
                  // open otp verification popup
                  verificationPopUp = await this.modalController.create({
                    component: OTPVerificationPage,
                    cssClass: 'custom-popup',
                    componentProps: {
                      userData: verificatioData,
                      operationType: 'verification_login',
                      previousCodeSentVia: verificationResponse.sentVia
                    }
                  });
                }

                if (verificationPopUp) {
                  await verificationPopUp.present();
                  // on dismiss check returned data 
                  verificationPopUp.onDidDismiss().then((response: any) => {
                    if (response.data && response.data.isVerified) {
                      this.proceedLogin();
                    } else {
                      this.loginInProgress = false;
                      this.verificationError = 'Verification failed, Please try again!'
                    }
                  });
                }

              }
            })
          } else { // verified user
            this.proceedLogin();
          }
        } else {
          this.loginInProgress = false;
          this.appService.appObject.errors = this.appService.getErrorArray(loginVerificationResponse.msg);
        }
      }).catch((error) => {
        console.log(error);
        this.loginInProgress = false;
      }).finally(() => {

      })
    } else {
      this.proceedLogin();
    }
  }
  /**
   * This login part is separated from login function due to verification part been implemented
   * so code won't repeat
   */
  proceedLogin() {
    this.loginInProgress = true;
    this.appService.login(this.login_details).then((response: any) => {
      // console.log('registered', response);
      if (response.status) {
        if (!this.appService.isWebVersion) {
          if (this.appService.isWhileRequestingPostalCode) {
            this.router.navigate(['home'], { queryParams: { requestPostalCode: true } });
          } else if (this.appService.isWhileRequestingNewPostalCode) {
            this.router.navigate(['home'], { queryParams: { requestNewPostalCode: true } });
          } else {
            this.appService.navigateToRegisterd();
          }
        } else {
          // console.log('This is Web version');
          this.onLoginSuccess.emit([response]);
        };
      }
      this.loginInProgress = false;
    }).catch((error) => {
      console.log('error : ', error);
      this.loginInProgress = false;
    })
  }

  async doGoogleLogin() {
    let userData = {
      email: '',
      first_name: '',
      last_name: '',
      mobile_number: "",
      tac: true,
      newsalert: "false",
      type: "google"
    }

    if (this.appService.isWebVersion || ((this.platform.is('android') || this.platform.is('ios')) && this.appService.isMobileWeb())) {
      await this.webAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then((socialUser) => {
        if (socialUser.authToken) {
          userData.email = socialUser.email;
          userData.first_name = socialUser.firstName;
          userData.last_name = socialUser.lastName;
        }
        console.log('social user (google) : ', socialUser);
      }).catch((error) => {
        console.log('google error : ', error);
      });

      // sign out after fetching details
      setTimeout(() => {
        this.webAuthService.signOut();
      }, 5000);

    } else {
      /*await this.googlePlus.login({
        'scopes': 'profile email', // optional - space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
        'webClientId': environment.GOOGLE_LOGIN_WEB_CLIENT_ID,// environment.googleWebClientId, // optional - clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
        'offline': true, // Optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
      })
        .then(googleUserResponse => {
          // console.log('Google Data : ', googleUserResponse);
          // this.appService.showAlert('success', 'console.log', JSON.stringify(googleUserResponse));
          userData.email = googleUserResponse['email'];
          userData.first_name = googleUserResponse['givenName'];
          userData.last_name = googleUserResponse['familyName'];
        }, err => {
          console.log('Error : ', err);
          // this.appService.showAlert('error', 'Something went wrong', JSON.stringify(err));
          this.appService.showAlert('error-detailed-info', 'google login error', JSON.stringify(err), false);
        });*/
    }

    if (userData.email) {
      this.appService.register(userData).then((registerResponse: any) => {
        // console.log('Register response : ', registerResponse);
        let isAuthorized = false;
        // check if the user already registered with this email address
        if (!registerResponse.status && registerResponse.already_exists) {
          isAuthorized = true;
        } else if (registerResponse.status) {
          isAuthorized = true;
        }

        if (isAuthorized) {
          // if it is, then log in to the app
          this.appService.login({
            email: userData.email,
            password: '',
            type: 'google'
          }).then((response: any) => {
            if (response.status) {
              if (!this.appService.isWebVersion) {
                if (this.appService.isWhileRequestingPostalCode) {
                  this.router.navigate(['home'], { queryParams: { requestPostalCode: true } });
                } else if (this.appService.isWhileRequestingNewPostalCode) {
                  this.router.navigate(['home'], { queryParams: { requestNewPostalCode: true } });
                } else {
                  this.appService.navigateToRegisterd();
                }
              }
              else {
                // console.log('This is Web version');
                this.onLoginSuccess.emit([response]);
              };
            }
          });
        }
        // logout google user after loging
        //this.googlePlus.logout()
        // otherwise user will be registered and logged in 
      }).catch((error) => {
        console.log('registerError : ', error);
      })
    }
  }


  async doFacebookLogin() {
    // console.log('window.origin : ', window.origin);
    // this.appService.showAlert('success', 'console.log', window.origin);
    // name, email
    let userData = {
      mobile_number: "",
      tac: true,
      newsalert: "false",
      type: "facebook",
      email: '',
      first_name: '',
      last_name: '',
    };

    if (this.appService.isWebVersion || ((this.platform.is('android') || this.platform.is('ios')) && this.appService.isMobileWeb())) {
      try {
        let socialUser = await this.webAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
        userData.email = socialUser.email;
        userData.first_name = socialUser.firstName;
        userData.last_name = socialUser.lastName;

        console.log('social user (facebook) : ', socialUser);
        // sign out after fetching details
        setTimeout(() => {
          this.webAuthService.signOut();
        }, 5000);
      } catch (error) {
        console.log('FB login web : ', error);
      }
    } else {
      /*await this.facebook.login(['public_profile', 'email']).then(async (response) => {
        await this.facebook.api('me?fields=id,name,email,first_name,last_name', []).then(profile => {
          userData.email = profile['email'];
          userData.first_name = profile['first_name'];
          userData.last_name = profile['last_name']
        });
        this.facebook.logout();
      }).catch((error) => {
        console.log('Error : ', error);
        this.appService.showAlert('error-detailed-info', 'facebook login error', JSON.stringify(error), false);
      })*/
    }

    // If email address contains means the data object is filled with valid data
    if (userData.email) {
      this.appService.register(userData).then((registerResponse: any) => {
        let isAuthorized = false;
        // check if the user already registered with this email address
        if (!registerResponse.status && registerResponse.already_exists) {
          isAuthorized = true;
        } else if (registerResponse.status) {
          isAuthorized = true;
        }

        if (isAuthorized) {
          // if it is, then log in to the app
          this.appService.login({
            email: userData.email,
            password: '',
            type: 'facebook'
          }).then((response: any) => {
            if (response.status) {
              if (!this.appService.isWebVersion) {
                if (this.appService.isWhileRequestingPostalCode) {
                  this.router.navigate(['home'], { queryParams: { requestPostalCode: true } });
                } else if (this.appService.isWhileRequestingNewPostalCode) {
                  this.router.navigate(['home'], { queryParams: { requestNewPostalCode: true } });
                } else {
                  this.appService.navigateToRegisterd();
                }
              }
              else {
                // console.log('This is Web version');
                this.onLoginSuccess.emit([response]);
              };
            }
          });
        }
        // otherwise user will be registered and logged in 
      }).catch((error) => {
        console.log('registerError : ', error);
      })
    }
  }

  async doAppleLogin() {
    let userData = {
      mobile_number: "",
      tac: true,
      newsalert: "false",
      type: "apple",
      email: '',
      first_name: '',
      last_name: '',
      user_id: '',
    };

    if (this.platform.is('ios') && !this.appService.isMobileWeb()) {
      this.apple.signin({ requestedScopes: [0, 1] }).then((response) => {
        if (response.user) {
          userData.email = response.email;
          userData.first_name = response.fullName.givenName;
          userData.last_name = response.fullName.middleName ? (response.fullName.middleName + ' ' + response.fullName.familyName) : response.fullName.familyName;
          userData.user_id = response.user;

          this.appService.register(userData).then((registerResponse: any) => {
            console.log('registerResponse : ', registerResponse);
            let isAuthorized = false;
            // check if the user already registered with this email address
            try {
              if (!registerResponse.status && registerResponse.already_exists) {
                console.log('Status is False, Already Exists True');
                isAuthorized = true;
              } else if (registerResponse.status) {
                console.log('Status is True');
                isAuthorized = true;
              }

              if (isAuthorized) {
                console.log('Finally Authenticated... Thank god');
                // this.appService.showAlert('error-detailed-info', 'authorized ', JSON.stringify(registerResponse), false);
                // if it is, then log in to the app
                this.appService.login({
                  email: userData.email,
                  user_id: userData.user_id,
                  password: '',
                  type: 'apple'
                }).then((response: any) => {
                  console.log('Login in response : ', response);
                  if (response.status) {
                    if (!this.appService.isWebVersion) {
                      if (this.appService.isWhileRequestingPostalCode) {
                        this.router.navigate(['home'], { queryParams: { requestPostalCode: true } });
                      } else if (this.appService.isWhileRequestingNewPostalCode) {
                        this.router.navigate(['home'], { queryParams: { requestNewPostalCode: true } });
                      } else {
                        this.appService.navigateToRegisterd();
                      }
                    }
                    else {
                      // console.log('This is Web version');
                      this.onLoginSuccess.emit([response]);
                    };
                  }
                });
              }
            } catch (error) {
              console.log('apple login error (try catch) : ', error);
            }
            // otherwise user will be registered and logged in 
          }).catch((error) => {
            console.log('registerError : ', error);
          })
        }
        // this.appService.showAlert('error-detailed-info', 'apple login response', JSON.stringify(response), false);
      }).catch((error) => {
        console.log('apple login error : ', error);
        // this.appService.showAlert('error-detailed-info', 'apple login error', JSON.stringify(error), false);
      })
    }
  }

  ionViewDidEnter() {
    this.login_details = {
      email: '',
      password: '',
      type: 'registered'
    };

    this.loginInProgress = false;

    if (this.appService.appObject.isAuthed) {
      this.router.navigate(['profile']);
    }


    setTimeout(() => {
      this.isCartIconShowing = this.appService.hideCartButton;
      this.appService.hideCartButton = true;
    }, 200);
  }

  ionViewDidLeave() {
    this.appService.hideCartButton = this.isCartIconShowing;
  }

  /**
   * Redirects to register via page
   */
  registerVia() {
    if (!this.appService.isWebVersion) this.router.navigate(['register'])
    else this.onRegisterClick.emit();
  }

  /**
   * Will trigger when user select forgot password link
   */
  onForgotPasswordClick() {
    if (!this.appService.isWebVersion) this.router.navigate(['forgot-password'])
    else this.onForgotPassword.emit();
  }

  emailvalidation() {
    if (this.login_details.email) {
      this.login_details.email = this.login_details.email.trim();
    }
  }

  /**
   * Will call when user click back icon (when user came to login page from checkout page)
   */
  navigateBackToCart() {
    if (this.appService.appObject && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.slug)
      this.router.navigate(['restaurant', this.appService.appObject.selectedRestaurantDetails.slug], { queryParams: { openCart: true } })
  }

  ngAfterViewInit() {
    if ((this.isOrderProcessing + '') === 'true') {
      setTimeout(() => {
        this.appService.appObject.isOrderProcess = true;
      }, 100);
    }
  }

  /**
   * When user click on checkout as guest
   */
  checkoutAsGuest() {
    if (!this.appService.isWebVersion) this.appService.checkoutAsGuest()
    else {
      this.appService.appObject.user.type = 'guest';
      this.onLoginSuccess.emit([]);
    }
  }
}
